export default {root:'m-347db0ec','root--dot':'m-fbd81e3d',label:'m-5add502a',section:'m-91fdda9b'};